// Org dashboard access: the organization_dashboard custom feature must be on for the account, the
// account must belong to an organization, and the viewer must be a Ubeya super admin. The accounts
// grid was briefly open to account owners as well (privilege id 1, the backend's ACCOUNT_OWNER);
// that is no longer the case - the whole view is Ubeya-internal.
export const canAccessOrgDashboard = ({ isUbeyaAdmin, organizationId, isOrganizationDashboardEnabled }) =>
  !!(isOrganizationDashboardEnabled && organizationId && isUbeyaAdmin);
